import React from 'react';
import { CourseCard } from './CourseCard';
import { ScrollReveal } from './ScrollReveal';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, AwardIcon } from 'lucide-react';
import { useBooking } from '../contexts/BookingContext';
export function CourseGrid() {
  const {
    openBooking
  } = useBooking();
  return <section id="kurse" className="py-16 md:py-24 bg-white" data-id="element-334">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-335">
        <ScrollReveal variant="up" data-id="element-336">
          <div className="text-center max-w-3xl mx-auto mb-12 md:mb-20" data-id="element-337">
            <span className="text-[#59d0d4] font-extrabold tracking-widest uppercase text-sm mb-4 block" data-id="element-338">
              Das Curriculum im Überblick
            </span>
            <h2 className="text-2xl md:text-5xl font-extrabold text-slate-700 mb-6 tracking-tight" data-id="element-339">
              Intensiv Curriculum Zahnmedizin
            </h2>
            <p className="text-base sm:text-lg text-slate-500 font-medium" data-id="element-340">
              Kursreihe von A - Z. Praxisnahe Weiterbildung & anerkannte
              Fortbildungspunkte für Zahnärzte.
            </p>
          </div>
        </ScrollReveal>

        <ScrollReveal variant="up" delay={100} data-id="element-341">
          <Link to="/kurse/intensiv-curriculum" className="block mb-10 group" data-id="element-342">
            <div className="bg-[#1a1a1a] rounded-3xl overflow-hidden shadow-xl border border-slate-800 hover:shadow-2xl transition-all duration-500 hover:-translate-y-1" data-id="element-343">
              <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-344">
                <div className="relative h-64 md:h-auto md:min-h-[320px] overflow-hidden" data-id="element-345">
                  <img src="https://cdn.rawproductionsgmbh.de/2n/home/curriculum.jpeg" alt="2N Intensiv Curriculum" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-346" />
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#1a1a1a]/60 hidden md:block" data-id="element-347"></div>
                  <div className="absolute inset-0 bg-gradient-to-t from-[#1a1a1a] to-transparent md:hidden" data-id="element-348"></div>
                </div>

                <div className="p-8 md:p-10 lg:p-12 flex flex-col justify-center relative" data-id="element-349">
                  <div className="absolute -top-20 -right-20 w-48 h-48 bg-[#59d0d4] rounded-full mix-blend-screen filter blur-[60px] opacity-20" data-id="element-350"></div>

                  <div className="relative z-10" data-id="element-351">
                    <div className="flex flex-wrap items-center gap-3 mb-4" data-id="element-352">
                      <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-amber-500/20 text-amber-400 text-xs font-extrabold uppercase tracking-wider border border-amber-500/30" data-id="element-353">
                        <AwardIcon className="w-3.5 h-3.5" data-id="element-354" />
                        78 Punkte
                      </span>
                      <span className="inline-flex items-center px-3 py-1 rounded-full bg-[#59d0d4]/15 text-[#59d0d4] text-xs font-extrabold uppercase tracking-wider border border-[#59d0d4]/30" data-id="element-355">
                        2.760 € Ersparnis
                      </span>
                    </div>

                    <p className="text-[#59d0d4] font-extrabold text-xs uppercase tracking-widest mb-2" data-id="element-356">
                      Ästhetik, Funktion & Praxisführung
                    </p>
                    <h3 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-white leading-tight mb-4 group-hover:text-[#59d0d4] transition-colors" data-id="element-357">
                      2N Intensiv Curriculum
                    </h3>
                    <p className="text-slate-400 font-medium leading-relaxed mb-6 max-w-md" data-id="element-358">
                      Gesamte Kursreihe A–D inklusive kostenfreiem
                      Alignertherapie-Kurs. Praxisnah, zertifiziert und mit
                      exklusivem Abendprogramm.
                    </p>

                    <div className="flex flex-wrap items-end gap-4 mb-6" data-id="element-359">
                      <div data-id="element-360">
                        <span className="text-slate-500 line-through text-sm font-medium block" data-id="element-361">
                          8.250 €
                        </span>
                        <span className="text-3xl font-extrabold text-white" data-id="element-362">
                          5.490 €
                        </span>
                        <span className="text-slate-500 text-sm font-medium ml-1" data-id="element-363">
                          zzgl. MwSt.
                        </span>
                      </div>
                    </div>

                    <span className="inline-flex items-center justify-center px-6 py-3 bg-[#59d0d4] hover:bg-[#4abfc3] text-[#1a1a1a] font-extrabold rounded-xl transition-all group-hover:shadow-[0_0_20px_rgba(89,208,212,0.4)]" data-id="element-364">
                      Zum Curriculum
                      <ArrowRightIcon className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-365" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </ScrollReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-10 mb-10 md:mb-16" data-id="element-366">
          <ScrollReveal variant="up" delay={100} className="h-full" data-id="element-367">
            <CourseCard title="A-Kurs White Aesthetics" subtitle="Ästhetische Zahnheilkunde" description="Moderne Fortbildung für weiße Ästhetik und perfekte Zahnrestaurationen." points={15} imageUrl="https://cdn.rawproductionsgmbh.de/2n/home/whiteaestetics.jpg" slug="white-aesthetics" data-id="element-368" />
          </ScrollReveal>

          <ScrollReveal variant="up" delay={200} className="h-full" data-id="element-369">
            <CourseCard title="B-Kurs Red Aesthetics" subtitle="Weichgewebsmanagement" description="Fortbildung für Zahnärzte zur Optimierung des Zahnfleischs und der roten Ästhetik." points={16} imageUrl="https://cdn.rawproductionsgmbh.de/2n/home/kursweichgewebe.jpg" slug="red-aesthetics" data-id="element-370" />
          </ScrollReveal>

          <ScrollReveal variant="up" delay={300} className="h-full" data-id="element-371">
            <CourseCard title="C-Kurs Funktion" subtitle="Funktionelle Zahnmedizin" description="Professionelle Fortbildung für okklusale Funktion und Kiefergelenkdiagnostik." points={16} imageUrl="https://cdn.rawproductionsgmbh.de/2n/home/kursfunktionellezahnmedizin.jpg" slug="funktionsanalyse-therapie" data-id="element-372" />
          </ScrollReveal>

          <ScrollReveal variant="up" delay={100} className="h-full" data-id="element-373">
            <CourseCard title="D-Kurs Champions League" subtitle="Praxismanagement & Strategie" description="Erfolgreiches Praxisteam & Leadership für Zahnärzte." points={15} imageUrl="https://cdn.rawproductionsgmbh.de/2n/home/kurspraxismanagement.jpeg" slug="champions-league" data-id="element-374" />
          </ScrollReveal>

          <ScrollReveal variant="up" delay={200} className="h-full" data-id="element-375">
            <CourseCard title="Female Boss" subtitle="Karriere-Workshop für Zahnärztinnen" description="Selbstständigkeit & Führungskompetenz gezielt stärken." points={7} imageUrl="https://cdn.rawproductionsgmbh.de/2n/home/kursfemaleboss.jpg" slug="female-boss" data-id="element-376" />
          </ScrollReveal>

          <ScrollReveal variant="up" delay={300} className="h-full" data-id="element-377">
            <CourseCard title="Alignertherapie" subtitle="Unsichtbare Zahnspange" description="Alignertherapie meistern und Umsätze steigern." points={16} imageUrl="https://cdn.rawproductionsgmbh.de/2n/home/kursalignertherapie.jpg" slug="alignertherapie" data-id="element-378" />
          </ScrollReveal>
        </div>

        <ScrollReveal variant="up" delay={200} data-id="element-379">
          <div className="text-center" data-id="element-380">
            <button onClick={openBooking} className="inline-flex items-center justify-center px-6 py-3.5 text-base sm:px-8 sm:py-4 sm:text-lg font-bold rounded-md text-white bg-[#3b7780] hover:bg-[#2d5f66] transition-all hover:scale-105 shadow-lg" data-id="element-381">
              Jetzt Kursplan sichern
              <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-382" />
            </button>
          </div>
        </ScrollReveal>
      </div>
    </section>;
}